export const testIndexes = [
  {
    id: '1',
    name: 'FATF-status',
    description: 'Lista över länder med strategiska brister i sitt arbete mot penningtvätt och terrorismfinansiering (FATF Grey List och Black List)',
    source: 'FATF',
    updateFrequency: 'QUARTERLY',
    lastUpdated: '2024-01-15',
    updatedBy: 'System Admin',
    status: 'ACTIVE',
    type: 'DOMINANT',
    calculationType: 'LIST_BASED',
    config: {
      type: "BOOLEAN",
      risks: ["Money Laundering Risk", "Terrorist Financing Risk", "Regulatory Risk"],
      settings: { impactType: 'score', riskScore: 100 },
      defaults: { displayValue: '-' }
    }
  },
  {
    id: '3',
    name: 'EU-högrisklistan',
    description: 'EU:s förteckning över tredjeländer med strategiska brister i sina system för bekämpning av penningtvätt och terrorismfinansiering',
    source: 'European Commission',
    updateFrequency: 'YEARLY',
    lastUpdated: '2024-02-14',
    updatedBy: 'System Admin',
    status: 'ACTIVE',
    type: 'DOMINANT',
    calculationType: 'LIST_BASED',
    config: {
      type: "BOOLEAN",
      risks: ["Money Laundering Risk", "Terrorist Financing Risk", "Regulatory Risk"],
      settings: { impactType: 'score', riskScore: 100 },
      defaults: { displayValue: '-' }
    }
  },
  {
    id: '2',
    name: 'Basel AML Index',
    description: 'Ranking av länder baserat på deras risk för penningtvätt och terrorismfinansiering',
    source: 'Basel Institute on Governance',
    updateFrequency: 'YEARLY',
    lastUpdated: '2023-12-01',
    updatedBy: 'John Doe',
    status: 'ACTIVE',
    type: 'WEIGHTED',
    calculationType: 'SCORE_BASED',
    calculation: {
      formula: 'score * 10',
      defaultScore: 50
    },
    config: {
      type: "SCORING",
      risks: ["Money Laundering Risk", "Corruption Risk", "Tax Evasion Risk"],
      scale: { maxValue: 10 },
      defaults: { displayValue: '-' }
    }
  }
];
